/**
 * This directive validates all tax codes.
 * It checks if the pair of region and taxes are unique and invalidates the form if not.
 *
 * Can probably only be used in the tax code dialog.
 *
 * @author Max.Niederauer
 */
angular.module('impactx.sapconfig').directive('ixTaxCodeValidator', function ($q) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ngModel) {
            var taxCodeCheck = scope.taxCode;
            var taxCodes = scope.$parent.$eval(attr.ixTaxCodeValidator);

            ngModel.$asyncValidators.invalidRegionCode = function (modelValue) {
                var deferred = $q.defer();
                var isInvalid = false;

                for (var i = 0; i < taxCodes.length; i++) {
                    if (isInvalid) {
                        break;
                    }
                    else {
                        if (taxCodeCheck.region.selected && taxCodes[i].region.selected && taxCodes[i].taxes.selected && (JSON.stringify(taxCodeCheck) !== JSON.stringify(taxCodes[i]))) {
                            if (taxCodeCheck.region.selected.id === taxCodes[i].region.selected.id) {
                                if (modelValue.id === taxCodes[i].taxes.selected.id) {
                                    isInvalid = true;
                                }
                            }
                        }
                        else {
                            isInvalid = false;
                        }
                    }
                }

                if (isInvalid) {
                    deferred.reject();
                }
                else {
                    deferred.resolve();
                }
                return deferred.promise;
            }
        }
    }
});